import React, { Component, Fragment } from "react";
import {
  Card,
  Row,
  Col,
  Badge
} from 'reactstrap';
import { SparkLine } from "../components";
import classnames from "classnames";
import moment from "moment";

export default class IngredientDataCard extends Component {
    constructor(props) {
        super(props);
        this.state = {

        };
    }

    render() {
        const result = this.props.result
        return (
            <Card className={`p-3 ${this.props.className ? this.props.className : ""}`}>
                {result &&
                    <Fragment>
                        <Row className="">
                            <Col>
                                <div className="p-2 centerText">
                                    <h6>{this.props.title}</h6>
                                <div className="italicText">{result.testTypeName}</div>
                                </div>
                                <div className="p-2 centerText">
                                    <Badge pill className={`${result.passed === false ? "cbdmdDanger" : "cbdmdPrimary"} fontSize150`}>
                                        <div>{result.concentrationDescription}</div>
                                    </Badge>
                                    <div className="italic">Concentration</div>
                                </div>
                                <div className="centerText mb-2">
                                <span className="boldText ">Range:</span>
                                {!result.beginningRange && !result.endingRange ? (
                                    <span className="ml-2 italicText"> {`Range not set`}</span>
                                ) : (
                                    <span className="ml-2 italicText"> {`${result.beginningRange} - ${result.endingRange}` || " - "}</span>
                                )}
                                </div>
                                <Row className="mb-2">
                                    <Col>
                                        <span className="boldText">LOQ: </span>
                                    <span className="ml-2 italicText">{result.loq || " - "}</span>
                                    </Col>
                                    <Col>
                                        <span className="boldText">LOD: </span>
                                    <span className="ml-2 italicText">{result.lod || " - "}</span>
                                    </Col>
                                </Row>
                                <div className="mb-2">
                                    <span className="boldText">Action Limit: </span>
                                    <span className="ml-2 italicText">{result.actionLimit || "N/A"}</span>
                                </div>
                                <div>
                                    <span className="boldText">Upper Limits: </span>
                                    <span className="ml-2 italicText">{result.upperLimits || "N/A"}</span>
                                </div>
                                <div className="mb-2">
                                    <span className="boldText">Test Date: </span>
                                <span>{result.dateTested ? moment(result.dateTested).format("M/DD/YYYY") : "N/A"}</span>
                                </div>
                            </Col>
                        </Row>
                        {this.props.data &&
                            <Row className="centerText mt-2">
                                <Col>
                                    <SparkLine
                                        data={this.props.data}
                                        color={this.props.color}
                                        title={"Ingredient Result Trend"}
                                        description={"Trend is based on last 30 test results"}
                                    />
                                </Col>
                            </Row>
                        }
                    </Fragment>
                }
            </Card>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/IngredientDataCard.js